import React, { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { Select, Checkbox, message } from "antd"
import { createPriorityStore } from "../../../services/api/apiReGenerateLabel"

const CreatePriorityStore = ({ modal, toggle, setModal, reload, err, listProductType, listStore }) => {

    const [newStore, setNewStore] = useState('')
    const [productType, setProductType] = useState([])
    const [error, setError] = useState({})
    const [loading, setLoading] = useState(false)
    const [isAllStore, setIsAllStore] = useState(false)

    const listNameSpace = Array.isArray(listStore) && listStore.map(item => item.namespace)

    const handleChange = values => {
        delete error.productType
        if (values.some(i => i.includes(','))) {
            setProductType(...values.map(i => i.split(",")))
        } else {
            setProductType([...values])
        }
    }

    const _handleChangeName = e => {
        let _timeOut = null

        const { value } = e.target
        delete error.newStore
        delete error.namespace

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            setNewStore(value)
        }, 500)
    }

    const _handleChangeCheck = e => {
        const { checked } = e.target
        delete error.productType
        setIsAllStore(checked)
    }

    const _handleCloseModal = () => {
        delete error.productType
        delete error.newStore
        delete error.namespace
        setNewStore('')
        setProductType([])
        setIsAllStore(false)
        toggle()
    }

    const _handleValidate = () => {
        const Err = {}
        let flag = true
        if (!newStore.trim()) Err.newStore = 'Bắt buộc nhập tên store!'
        if (listNameSpace.includes(newStore.trim())) Err.namespace = 'Store đã tồn tại!'
        if (productType.length < 1 && !isAllStore) Err.productType = "Bắt buộc nhập product type!"

        setError(Err)

        if (Object.keys(Err).length > 0) return flag = false
        return flag
    }

    const _handleSubmit = async () => {

        const validate = _handleValidate()
        if (!validate) {
            setLoading(false)
            return
        }
        setLoading(true)
        setError({})

        try {
            const payload = {
                namespace: newStore.trim(),
                apply_for_all: isAllStore
            }
            if (productType.length) payload.product_types = productType

            const { data } = await createPriorityStore(payload)
            const { success, message: mes } = data
            if (!success) {
                setLoading(false)
                setModal()
                return message.error(mes)
            }

            setLoading(false)
            setError({})
            message.success('Thêm mới store thành công!')
            reload()
            setModal()
            setProductType([])
            setIsAllStore(false)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    return (
        <Modal isOpen={modal} toggle={_handleCloseModal}>
            <ModalHeader toggle={_handleCloseModal}>Thêm mới store ưu tiên</ModalHeader>
            <ModalBody>
                <div className="NameStore mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Store</label>
                    <div className="col-sm-9">
                        <input
                            className="ant-input"
                            placeholder="Nhập namespace"
                            onChange={_handleChangeName}
                        />
                        {!!error.newStore && (
                            <div className="text-danger mt-1">{error.newStore}</div>
                        )}
                        {!!error.namespace && (
                            <div className="text-danger mt-1">{error.namespace}</div>
                        )}
                    </div>
                </div>
                <div className="ProductType mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Product type</label>
                    <div className="col-sm-9">
                        <Select
                            options={listProductType}
                            value={productType}
                            mode="tags"
                            allowClear
                            showArrow
                            disabled={isAllStore}
                            style={{
                                width: '100%',
                            }}
                            placeholder="-- Chọn product type --"
                            onChange={handleChange}
                        />
                        <Checkbox
                            onChange={_handleChangeCheck}
                            checked={isAllStore}
                            className="mt-3"
                        >All product type
                        </Checkbox>
                        {!!err && (
                            <div className="text-danger mt-1">{err}</div>
                        )}
                        {!!error.productType && (
                            <div className="text-danger mt-1">{error.productType}</div>
                        )}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary mr-auto" disabled={loading} onClick={_handleCloseModal}>
                    Hủy
                </button>
                <button className="btn btn-primary" disabled={loading} onClick={_handleSubmit}>
                    Lưu
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default CreatePriorityStore